import { render } from "./DataTableFilters.vue?vue&type=template&id=fbff841e"
import script from "./DataTableFilters.vue?vue&type=script&lang=js"
export * from "./DataTableFilters.vue?vue&type=script&lang=js"

import "./DataTableFilters.vue?vue&type=style&index=0&id=fbff841e&lang=css"

import exportComponent from "/builds/uf-manage/mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__